<template>
  <md-dialog :md-active.sync="isVisible" :md-backdrop="true">
    <md-dialog-title>Remove Team Member</md-dialog-title>

    <md-dialog-content>
      <p>Are you sure you want to remove the selected team member</p>
    </md-dialog-content>

    <md-dialog-actions>
      <md-button class="md-primary" @click="confirm()">Yes</md-button>
      <md-button class="md-accent" @click="close()">No</md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<style scoped></style>

<script>
export default {
  name: 'confirm-modal',
  props: ['removeBusinessAccess'],
  data() {
    return {
      isVisible: false,
      item: {},
    };
  },
  methods: {
    open(item) {
      this.isVisible = true;
      this.item = item;
    },
    close() {
      this.isVisible = false;
    },
    confirm() {
      this.removeBusinessAccess(this.item);
    },
  },
};
</script>
